import cx from "classnames";
import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import { Doctor, IC } from "../../../resources/Assets";
import { Container, DateLayer, openAlertPopup } from "../../Layout";

// Temp Images
import _CHART_CIRCLE from "../../../resources/images/icon/chart_circle.png";
import _CHART_SQUARE from "../../../resources/images/icon/chart_square.png";

import {
  PostApi1203,
  PostApi1204,
  PostApi1205,
} from "../../../modules/network/padoPost";

import { addDays, addMonths, format } from "date-fns";

import { NativeAction } from "../../../modules/utils/HandleWs";
import {
  PeriodTypeChange,
  convertFormat,
} from "../../../modules/utils/PeriodTypeChange";
import { userHabit } from "../../../modules/utils/UserHabit";
import { FullScreenBs } from "../FullScreen";
import BsGraph from "./Graph/BsGraph";
import useTitle from "../../../modules/hooks/useTitle";

const interfaceDateFormat = "yyyyMMdd";

export const SUBS = [
  { url: "/sm/bs/input", code: "bloodinput", label: "혈당관리" },
  { url: "/sm/bs/medicine/input", code: "medicineinput", label: "복약입력" },
  { url: "/sm/bs/3/1/1", code: "bloodhistory", label: "혈당이력" },
  // { url: "/sm/bs/list/3/1/1", code: "bloodhistory", label: "혈당이력" },
  { url: "/sm/bs/medicine", code: "medicinehistory", label: "복약이력" },
];

export const SubMenu = props => {
  const { code } = props;

  return (
    <div className="top-roundtab-contain">
      <ul>
        {SUBS.map((m, i) => (
          <li key={i}>
            <Link to={m.url} className={cx({ on: code === m.code })}>
              {m.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default props => {
  useTitle("자가건강관리_혈당_그래프");
  const { userinfo, cfg, phonecfg, auth, dispatch } = useContext(AppContext);
  const sub = SUBS[2];

  const [list, setList] = useState();

  const [periodType, setPeriodType] = useState(
    parseInt(props.match.params.periodType)
  );
  const [startDate, setStartDate] = useState(
    props.match.params.startDate && props.match.params.startDate == "1"
      ? convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
      : props.match.params.startDate
  );
  const [endDate, setEndDate] = useState(
    props.match.params.endDate && props.match.params.endDate == "1"
      ? convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
      : props.match.params.endDate
  );

  const [mealType, setMealType] = useState("");

  const [totalCnt, setTotalCnt] = useState();
  const [reload, setReload] = useState(false);

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
    requestAll();
  };

  const request1203 = (
    userinfo,
    cfg,
    periodType,
    searchFrDt,
    searchToDt,
    mealType
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFrDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1203(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        mealType
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setList(res);
            // setTotalCnt(res.result.totalCnt);

            if (res.result.totalCnt === "0") {
              request1205(
                userinfo,
                cfg,
                periodType,
                startDate,
                endDate,
                1,
                500
              );
            } else {
              setTotalCnt(res.result.totalCnt);
            }
          } else {
            console.log("LOGOUT!!!");
            // alert('token error');
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  // 그래프 옵션 필요 값
  const [graphParam, setGraphParam] = useState("");

  const request1204 = (
    userinfo,
    cfg,
    periodType,
    searchFrDt,
    searchToDt,
    mealType
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFrDt;
        reqEndDate = searchToDt;
        break;
    }

    if (periodType === 4) {
      if (reqStartDate != "" && reqEndDate != "") {
        if (reqStartDate > reqEndDate) {
          openAlertPopup("검색기간을 확인하세요");
          return;
        }
      }
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1204(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        reqStartDate,
        reqEndDate,
        mealType
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            setGraphParam(res.result);
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const requestAll = () => {
    if (periodType === 4) {
      if ($(".pick-num1").val() != "" && $(".pick-num2").val() != "") {
        request1203(userinfo, cfg, periodType, startDate, endDate, mealType);
        request1204(userinfo, cfg, periodType, startDate, endDate, mealType);
      } else {
        setTotalCnt("0");
      }
    } else {
      request1203(userinfo, cfg, periodType, startDate, endDate, mealType);
      request1204(userinfo, cfg, periodType, startDate, endDate, mealType);
    }
  };

  const request1205 = (
    userinfo,
    cfg,
    periodType,
    searchFromDt,
    searchToDt,
    pageNo,
    pageCnt
  ) => {
    let reqStartDate = "";
    let reqEndDate = format(new Date(), interfaceDateFormat);
    switch (periodType) {
      case 1:
        reqStartDate = format(addDays(new Date(), -6), interfaceDateFormat);
        break;
      case 2:
        reqStartDate = format(addMonths(new Date(), -1), interfaceDateFormat);
        break;
      case 3:
        reqStartDate = format(addMonths(new Date(), -3), interfaceDateFormat);
        break;
      default:
        reqStartDate = searchFromDt;
        reqEndDate = searchToDt;
        break;
    }

    if (reqStartDate != "" && reqEndDate != "" && reqStartDate <= reqEndDate) {
      PostApi1205(
        userinfo,
        cfg,
        phonecfg,
        periodType,
        searchFromDt,
        searchToDt,
        pageNo,
        pageCnt
      )
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            if (res.totalCnt > 0) {
              // setTotalCnt(res.length.toString())
              _O.Open(
                "/sm/bs/list/" + periodType + "/" + startDate + "/" + endDate
              );
            } else {
              setTotalCnt("0");
            }
          } else {
            console.log("LOGOUT!!!");
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      if (reqStartDate.length == 8 && reqEndDate.length == 8) {
        if (
          reqStartDate != "" &&
          reqEndDate != "" &&
          reqStartDate > reqEndDate
        ) {
          openAlertPopup("선택한 날짜를 확인하세요.");
        }
      }
    }
  };

  useEffect(() => {
    requestAll();
  }, [periodType, mealType, startDate, endDate, totalCnt]);

  useEffect(() => {
    userHabit(phonecfg, "BS130");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <Container
        Title={sub.label}
        bottom={totalCnt === "0" ? <Bottom /> : null}
        goToUrl="/sm"
        color="green">
        <div className="contents sub">
          <SubMenu code={sub.code} />

          <div className="sub-contents">
            <div className="date-setting-area">
              <div className="btns">
                <a
                  onClick={() => setPeriodType(1)}
                  className={periodType == 1 ? "on" : ""}>
                  1주일
                </a>
                <a
                  onClick={() => setPeriodType(2)}
                  className={periodType == 2 ? "on" : ""}>
                  1개월
                </a>
                <a
                  onClick={() => setPeriodType(3)}
                  className={periodType == 3 ? "on" : ""}>
                  3개월
                </a>
                <a
                  onClick={() => setPeriodType(4)}
                  className={
                    // periodType == 4 ? "btn-selfinput on" : "btn-selfinput"
                    `btn-selfinput ${periodType == 4 ? "on" : ""}`
                  }>
                  기간설정
                </a>
              </div>
              <div
                className="date-input"
                style={
                  periodType === 4 ? { display: "block" } : { display: "none" }
                }>
                <div className="round-bar">
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num1"
                      data-num="1"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        startDate.length == 8
                          ? startDate.substring(0, 4) +
                            "." +
                            startDate.substring(4, 6) +
                            "." +
                            startDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                  <u>~</u>
                  <div className="ipbox">
                    <input
                      type="text"
                      placeholder="선택하세요."
                      readOnly
                      className="date-picker-input pick-num2"
                      data-num="2"
                      defaultValue={
                        props.match.params.periodType == "4" &&
                        endDate.length == 8
                          ? endDate.substring(0, 4) +
                            "." +
                            endDate.substring(4, 6) +
                            "." +
                            endDate.substring(6, 8)
                          : ""
                      }
                    />
                    <i></i>
                  </div>
                </div>
              </div>
            </div>
            {totalCnt && totalCnt !== "0" ? (
              <History
                setPeriodType={setPeriodType}
                setMealType={setMealType}
                list={list}
                graphParam={graphParam}
                mealType={mealType}
                periodType={periodType}
                startDate={startDate}
                endDate={endDate}
                reload={reload}
                setReload={setReload}
              />
            ) : totalCnt && totalCnt === "0" ? (
              <Nothing />
            ) : null}
          </div>
        </div>
      </Container>
      <DateLayer handleDate={handleDate} color="green" />
      <FullScreenBs
        startDate={startDate}
        endDate={endDate}
        periodType={periodType}
        type={mealType}
        reload={reload}
        setReload={setReload}
      />
    </Fragment>
  );
};

const History = memo(props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [dropBoxActive, setDropBoxActive] = useState(false);

  const {
    setPeriodType,
    setMealType,
    list,
    graphParam,
    mealType,
    periodType,
    startDate,
    endDate,
    reload,
    setReload,
  } = props;

  const openFullScreen = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      window.java.appDisplayRotation(false);
      $("#fullScreen").show();
      userHabit(phonecfg, "BS132");
    } else {
      window.location.href = "ep://appDisplayRotation/";
      $("#fullScreen").show();
      userHabit(phonecfg, "BS132");
    }

    setReload(true);
  };

  return (
    <Fragment>
      {/* <!-- ~님 혈압수치를 관리해 주세요. --> */}
      <div className="doctor-massage-box">
        <div className="dot-photo">
          {list &&
            list.result.bsResult !== "" &&
            (list.result.bsResult === "NORMAL" ? (
              <img src={Doctor.male.good} alt="" />
            ) : (
              list.result.bsResult === "HIGH" && (
                <img src={Doctor.male.bad} alt="" />
              )
            ))}
        </div>
        <p>
          ‘{userinfo.userName} 님’ {list ? list.result.checkDay : 0}일 동안 높은
          혈당이 {list ? list.result.cnt : 0}회 측정되었습니다.
          <br />
          혈당수치를 관리해주세요!
        </p>
      </div>

      <div className="section-box">
        <div className="sub-title">
          혈당 그래프
          <div className="btn-right">
            <a
              onClick={e =>
                _O.Open(
                  periodType === 4
                    ? "/sm/bs/list" +
                        "/" +
                        periodType +
                        "/" +
                        startDate +
                        "/" +
                        endDate
                    : "/sm/bs/list" + "/" + periodType + "/1/1"
                )
              }>
              혈당 목록
            </a>
          </div>
        </div>

        <div className="graph-under-note">
          <img src={_CHART_CIRCLE} style={{ width: "10px" }} />
          <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>식전</span>
          <img src={_CHART_SQUARE} style={{ width: "10px" }} />
          <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>식후</span>

          <div
            className="select-area tw"
            style={{
              width: "120px",
              height: "32px",
              right: "0",
              position: "absolute",
              top: "0",
            }}>
            <div style={{ width: "100%", marginLeft: "0px" }}>
              <div
                className={
                  dropBoxActive
                    ? "select-custom-box in5 on"
                    : "select-custom-box in5"
                }>
                <a
                  className="btn-select"
                  style={{
                    height: "32px",
                    lineHeight: "32px",
                    fontSize: "12px",
                  }}
                  onClick={() => setDropBoxActive(true)}>
                  전체
                </a>
                <ul style={{ top: "33px" }}>
                  <li>
                    <a
                      onClick={() => {
                        setMealType("");
                        setDropBoxActive(false);
                      }}>
                      전체
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        setMealType("B");
                        setDropBoxActive(false);
                      }}>
                      식사전
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        setMealType("A");
                        setDropBoxActive(false);
                      }}>
                      식사후
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {graphParam != "" && (
          <BsGraph graphParam={graphParam} mealType={mealType} />
        )}

        <div className="graph-under-note">
          <a onClick={() => openFullScreen()} className="btn-zoom">
            그래프 확대<i></i>
          </a>
        </div>
      </div>
    </Fragment>
  );
});

const Bottom = () => {
  return (
    <div className="under-fix-btnarea">
      <Link to="/sm/bs/input" className="btn-inputok">
        <i></i>입력
      </Link>
    </div>
  );
};

const Nothing = props => {
  return (
    <div className="sub-contents">
      <div className="nothing-box">
        <div>
          <img src={IC.empty.bp} alt="" />
          <p>
            입력하신 정보가 없습니다.
            <br />
            혈당정보를 입력해 주세요.
          </p>
        </div>
      </div>
    </div>
  );
};
